<script setup name="TvbHomeEpg">
import { inject, reactive } from 'vue'
import dayjs from 'dayjs'
import zhHK from 'dayjs/locale/zh-hk'
import { getMyTvChannels } from './../../../../api/home'

dayjs.locale(zhHK)

defineProps({
  info: {
    type: Object,
    default: null
  }
})

const size = inject('size')
const epg = reactive({
  loading: false,
  list: [],
  more_url: '',
  time: dayjs(),
  total: null
})

const getEpg = () => {
  if (epg.loading) return
  epg.loading = true
  getMyTvChannels()
    .then(({ data }) => {
      for (const key in data) {
        if (key === 'time') {
          data[key] = dayjs(data[key] * 1000)
        }
        epg[key] = data[key]
      }
      setTimeout(() => {
        epg.loading = false
      }, 1500)
    })
    .catch((err) => {
      console.error(err)
      epg.loading = false
    })
}

getEpg()
</script>

<template>
  <div class="tvb-home-epg" :class="[size]">
    <header class="tvb-home-epg-header">
      <h2 class="tvb-home-epg-title">
        <component :is="epg?.more_url ? 'tvb-router-link' : 'span'" :to="epg?.more_url">
          {{ info.title }}
        </component>
      </h2>
      <button class="tvb-home-epg-refresh" @click="getEpg" :disabled="epg.loading">
        <n-spin :rotate="epg.loading" content-class="tvb-home-epg-refresh-icon">
          <template #icon>
            <TvbSvgIcon name="icon_epg_refresh" />
          </template>
        </n-spin>
        <span>{{ epg.loading ? '正在更新' : '按此更新' }}</span>
      </button>
      <tvb-button
        class="tvb-home-epg_more"
        :type="!['s', 'xs'].includes(size) ? 'more' : 'more-text'"
        :animation="!['s', 'xs'].includes(size) ? 'more' : ''"
        icon="icon_list_arrow_grey"
        :path="epg.more_url"
        :style="{ '--tvb-button-height': ['s', 'xs'].includes(size) ? '24px' : '36px' }"
        >查看更多</tvb-button
      >
    </header>
    <main class="tvb-home-epg-main tvb-hairline--surround">
      <div class="tvb-home-epg-time">
        <time class="tvb-home-epg-yyyy" :datetime="epg.time.toString()">
          {{ epg.time.format('YYYY-MM-DD') }}({{ epg.time.format('dd') }})
        </time>
        <time class="tvb-home-epg-hh" :datetime="epg.time.toString()">
          {{ epg.time.format('hh:mm A') }}
        </time>
      </div>
      <div class="tvb-home-epg-items">
        <a
          class="tvb-home-epg-item"
          v-for="(item, index) in epg.list"
          :href="item.jump_url"
          :key="index"
        >
          <tvb-image
            :is-loading-icon="false"
            class="tvb-home-epg-icon"
            :src="`/image/img_epg_${item.channel_no}_logo.png`"
            :alt="`${item.name_tc}`"
            :srcset="`/image/img_epg_${item.channel_no}_logo@2x.png 2x`"
          />
          <p
            class="tvb-home-epg-programme-title"
            :title="`${item.current_programme.programme_title_tc}`"
          >
            {{ item.current_programme.programme_title_tc }}
          </p>
        </a>
      </div>
    </main>
  </div>
</template>

<style lang="scss" scoped>
.tvb-home-epg {
  // margin-top: 56px;
  min-width: 320px;
  .tvb-home-epg-header {
    display: flex;
    align-items: center;

    .tvb-home-epg-title {
      font-size: 24px;
      font-weight: 500;
      color: #1e1e1e;
      line-height: 36px;
      letter-spacing: 0.5px;
      > a {
        text-decoration: none;
        color: inherit;
        transition: color 0.15s linear;
        &:hover {
          color: rgba(0, 98, 163, 1);
        }
      }
    }

    .tvb-home-epg-refresh {
      width: 93px;
      height: 28px;
      background: #fea430;
      border-radius: 5px;
      border: 0;
      outline: 0;
      cursor: pointer;
      margin-left: 12px;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      letter-spacing: 0.3px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:active {
        opacity: 0.8;
      }

      :deep(.n-spin) {
        --n-size: 16px !important;
        &.n-spin--rotate {
          animation: spin-rotate 1s linear infinite !important;
        }
      }

      // svg {
      // }
      :deep(.n-spin-body) {
        margin-right: 2px;
      }
    }

    :deep(.tvb-home-epg_more) {
      margin-left: auto;

      &.btn-more-text {
        position: relative;
        top: 1px;
      }

      &.btn-more .svg-icon {
        margin-left: 1px;
      }
    }
  }

  .tvb-home-epg-main {
    height: 138px;
    background: #f8f9fa;
    border-radius: 8px;
    --tvb-hairline-border-radius: calc(2 * 8px);
    margin-top: 16px;
    display: flex;
    .tvb-home-epg-time {
      width: 256px;
      height: 138px;
      background: #0062a3;
      border-radius: 8px 0px 0px 8px;
      margin-right: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      letter-spacing: 0.5px;

      .tvb-home-epg-yyyy,
      .tvb-home-epg-hh {
        width: 155.72px;
        font-size: 22px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.9);
        line-height: 32px;
        display: block;
        white-space: nowrap;
      }
    }

    .tvb-home-epg-items {
      margin-left: 16px;
      width: calc(100% - 256px - 16px * 2);
      display: flex;

      .tvb-home-epg-item {
        width: calc((100% - 16px * 4) / 2);
        padding-right: 16px;
        margin-right: 16px;
        display: block;
        text-decoration: none;

        &:last-child {
          margin-right: 0;
        }

        .tvb-home-epg-icon {
          width: 100px;
          height: 32px;
          margin-top: 24px;
        }

        .tvb-home-epg-programme-title {
          font-size: 20px;
          font-weight: 500;
          color: #333333;
          line-height: 26px;
          letter-spacing: 0.5px;
          word-break: break-all;
          margin-top: 6px;
          transition: color 0.15s linear;

          @include line-text-ellipsis(2);
          &:hover {
            color: rgba(0, 98, 163, 1);
          }
        }
      }
    }
  }
  &.s {
    padding: 0px 16px !important;
  }

  &.s,
  &.xs {
    // margin-top: 44px;
    padding: 0 12px;
    .tvb-home-epg-header {
      .tvb-home-epg-title {
        font-size: 17px;
        font-weight: 500;
        color: #1e1e1e;
        line-height: 24px;
      }

      .tvb-home-epg-refresh {
        justify-content: flex-start;
        width: 83px;
        height: 24px;
        background: #fea430;
        border-radius: 4px;
        font-size: 13px;
        font-weight: 400;
        color: #ffffff;
        line-height: 18px;
        margin-left: 8px;
        letter-spacing: 0;
        padding: 0 9px 0 6px;
        &:active {
          opacity: 0.8;
        }

        :deep(.n-spin) {
          --n-size: 14px !important;
        }
      }
    }

    .tvb-home-epg-main {
      flex-direction: column;
      border-radius: 6px;
      --tvb-hairline-border-radius: calc(2 * 6px);
      margin-top: 10px;

      height: auto;
      .tvb-home-epg-time {
        height: 36px;
        background: #0062a3;
        border-radius: 6px 6px 0px 0px;
        width: 100%;
        flex-direction: row;
        justify-content: flex-start;
        letter-spacing: 0.3px;
        .tvb-home-epg-yyyy {
          margin: 0 6px 0 12px;
        }
        .tvb-home-epg-yyyy,
        .tvb-home-epg-hh {
          font-size: 14px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.9);
          line-height: 20px;
          width: auto;
        }
      }

      .tvb-home-epg-items {
        margin-left: 0;
        width: 100%;
        flex-direction: column;
        padding: 4px 0;

        .tvb-home-epg-item {
          display: flex;
          align-items: center;
          width: 100%;
          margin: 0;
          padding: 10px 12px;

          &:active {
            opacity: 0.8;
          }
          .tvb-home-epg-icon {
            width: 68px;
            min-width: 68px;
            height: 22px;
            margin: 0;
          }

          .tvb-home-epg-programme-title {
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
            margin: 0;
            padding: 0 0 0 19px;
            @include line-text-ellipsis(1);
          }
        }
      }
    }
  }
}
</style>
